import { useEffect } from "react";
import { useConnectionState } from "./zustand/ConnectionState";
import { useChatListState } from "./zustand/ChatListState";

export const useNetworkStatus = () => {
  const setNetworkStatus = useConnectionState(
    (state) => state.setNetworkStatus,
  );

  const setLastOnlineTimestamp = useConnectionState(
    (state) => state.setLastOnlineTimestamp,
  );

  const setLastOfflineTimestamp = useConnectionState(
    (state) => state.setLastOfflineTimestamp,
  );

  const setChatListSyncing = useChatListState(
    (state) => state.setChatListSyncing,
  );

  useEffect(() => {
    const handleOnline = async () => {
      setNetworkStatus("online");
      setLastOnlineTimestamp(new Date().toISOString());
    };

    const handleOffline = () => {
      setNetworkStatus("offline");
      // reset chat list syncing state
      setChatListSyncing(false);
      // set new offline timestamp
      setLastOfflineTimestamp(new Date().toISOString());
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [
    setNetworkStatus,
    setLastOnlineTimestamp,
    setLastOfflineTimestamp,
    setChatListSyncing,
  ]);
};
